import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import LogoApstore from "../../assets/app-store.png";
import LogoGooglePlay from "../../assets/google-play.png";
import Logo from "../../assets/logo.png";
import { t } from "../../translations";
import "../styles/footer.css";

const Footer = () => {
  const setting = useSelector((state) => state.setting);
  const user = useSelector((state) => state.user);
  const lang = useSelector((state) => state.lang);

  return (
    <div className="container">
      <div className="content">
        <div className="footer-content">
          <img src={Logo} alt="" className="logo" />
          <div className="element">
            <div className="footer-section">
              <h2>{t("ui.learn", lang)}</h2>
              <Link to="/our-story">{t("ui.notre_histoire", lang)}</Link>
              <Link to="/food-safety">{t("ui.scurit_alimentaire", lang)}</Link>
              <a>{t("ui.centre_d", lang)}</a>
              <Link to="/community-guidelines">
                {t("ui.service_communautaire", lang)}
              </Link>
              <a href="/panichefs-academy" target="_blank" rel="noreferrer">
                {t("ui.panichef_academy", lang)}
              </a>
            </div>
            <div className="footer-section">
              <h2>{t("ui.communaut", lang)}</h2>
              <a
                href="https://www.linkedin.com/company/panichefs/"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61558856653614"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/panichefs/"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
              <a
                href="https://www.tiktok.com/@panichefs?is_from_webapp=1&sender_device=pc"
                target="_blank"
                rel="noreferrer"
              >
                TikTok
              </a>
            </div>
            <div className="footer-section">
              <h2>{t("ui.ressources", lang)}</h2>
              {user?.chef === false && user?.restaurant === false && (
                <Link to="/become-a-chef">
                  {t("ui.devenir_chef", lang, user?.restaurant)}
                </Link>
              )}
              {(user?.chef === true || user?.restaurant === true) && (
                <Link to="/chef/iam-a-chef/home">
                  {t("ui.mon_dashboard", lang)}
                </Link>
              )}
              <Link to="/careers">{t("ui.carrire", lang)}</Link>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-bottom">
          <div className="left">
            <Link to="/privacy-policy">
              {t("content.privacy_policy", lang)}
            </Link>
            <Link to="/terms-of-service">
              {t("content.terms_conditions", lang)}
            </Link>
          </div>
          <div className="right">
            <a>Pani, Inc 2023. {t("ui.tous_droits_reservs", lang)}</a>
            <a
              href={setting?.social?.url_to_app}
              target="_blank"
              rel="noreferrer"
            >
              <img src={LogoApstore} alt="" className="store-icon" />
            </a>
            <a
              href={setting?.social?.url_to_app}
              target="_blank"
              rel="noreferrer"
            >
              <img src={LogoGooglePlay} alt="" className="store-icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
